import type { Routes } from '@angular/router';

import { accountGuard, accountSwitcherGuard } from './core/auth/account.guard';
import { authGuard } from './core/auth/auth.guard';
import { onboardingGuard } from './core/auth/onboarding.guard';
import { AppShellComponent } from './shared/layout/app-shell.component';

export const routes: Routes = [
  {
    path: 'login',
    loadChildren: () => import('./features/auth/auth.routes'),
  },
  {
    path: 'logout',
    loadComponent: () => import('./features/auth/logout.component').then((m) => m.LogoutComponent),
    data: { title: 'Logging out' },
  },
  {
    // Onboarding sits outside the AppShell so it gets its own full-bleed
    // layout (no top nav). It still requires an Auth0 session, but
    // intentionally does NOT run `onboardingGuard` (otherwise it would
    // redirect to itself indefinitely).
    path: 'onboarding',
    canActivate: [authGuard],
    loadChildren: () => import('./features/onboarding/onboarding.routes'),
  },
  {
    path: '',
    component: AppShellComponent,
    canActivate: [authGuard, onboardingGuard],
    children: [
      // The account switcher deliberately omits `accountGuard` — it is where a
      // multi-account user with no determined account goes to pick one. It runs
      // `accountSwitcherGuard` instead, which keeps zero/one-account users out
      // (they have nothing to switch). Every other shell route requires a
      // determined account.
      {
        path: '',
        canActivate: [accountGuard],
        loadChildren: () => import('./features/home/home.routes'),
      },
      {
        path: 'plans',
        canActivate: [accountGuard],
        loadChildren: () => import('./features/plans/plans.routes'),
      },
      {
        path: 'plans/:planId',
        canActivate: [accountGuard],
        loadChildren: () => import('./features/plan/plan.routes'),
      },
      {
        path: 'account',
        canActivate: [accountSwitcherGuard],
        loadChildren: () => import('./features/account/account.routes'),
      },
      {
        path: 'me',
        canActivate: [accountGuard],
        loadChildren: () => import('./features/settings/settings.routes'),
      },
      {
        path: 'admin',
        canActivate: [accountGuard],
        loadChildren: () => import('./features/admin/admin.routes'),
      },
    ],
  },
  {
    path: '**',
    loadComponent: () => import('./features/errors/not-found.component'),
  },
];
